export const IMAGE_POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right',
} as const;

export type IMAGE_POSITION = typeof IMAGE_POSITIONS[keyof typeof IMAGE_POSITIONS];